import * as ActionTypes from '../constants/ActionTypes'

export const tokenReducer = (state = {bearer: "", expires: "", isAuthenticatedUser: false}, action) => {

    switch (action.type) {

        case ActionTypes.AUTHENTICATION_SUCCESS:
            if (!action.response) {
                return state
            }
            return Object.assign({}, state, {
                bearer: action.response.entities.tokens.token.token,
                expires: action.response.entities.tokens.token.expires,
                isAuthenticatedUser: true
            })

        case ActionTypes.BEARER_TOKEN_SUCCESS:
            if (!action.response) {
                return state
            }
            return Object.assign({}, state, {
                bearer: action.response.entities.tokens.token.token,
                expires: action.response.entities.tokens.token.expires,
                isAuthenticatedUser: false
            })

        case ActionTypes.CLIENTDATA_SELECT_NEW:
            return Object.assign({}, state, {
                isAuthenticatedUser: false
            })
        default:
            return state;

    }

}


/** WEBPACK FOOTER **
 ** ./src/reducers/Token.js
 **/